<div class="flex items-center justify-center h-full">
    <progress class="progress progress-primary w-56" />
</div>
